import { Icon, IconProps } from './Icon';

interface ThreeDotsIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
  backgroundColor?: string;
  foregroundColor?: string;
}

export const ThreeDotsIcon = ({
  color = '#5E6A81',
  backgroundColor,
  foregroundColor = '#FEFEFE',
  gradient,
  ...props
}: ThreeDotsIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    <defs>
      <clipPath id={`clip-${gradient?.id || 'default'}`}>
        <rect
          y="28"
          width="28"
          height="28"
          rx="14"
          transform="rotate(-90 0 28)"
          fill="white"
        />
      </clipPath>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <g clipPath={`url(#clip-${gradient?.id || 'default'})`}>
      <rect
        y="28"
        width="28"
        height="28"
        rx="14"
        transform="rotate(-90 0 28)"
        fill={gradient ? `url(#${gradient.id})` : backgroundColor || color}
      />
      <path
        d="M0 14C0 16.7689 0.821086 19.4757 2.35943 21.778C3.89776 24.0803 6.08427 25.8747 8.64243 26.9343C11.2006 27.9939 14.0155 28.2712 16.7313 27.731C19.447 27.1908 21.9416 25.8574 23.8995 23.8995C25.8574 21.9416 27.1908 19.447 27.731 16.7313C28.2712 14.0155 27.9939 11.2006 26.9343 8.64243C25.8747 6.08426 24.0803 3.89776 21.778 2.35942C19.4757 0.821085 16.7689 0 14 0C10.2881 0.00361633 6.72922 1.47977 4.1045 4.1045C1.47977 6.72922 0.0036161 10.2881 0 14ZM23.0283 14C23.0283 14.6049 22.788 15.1851 22.3602 15.6129C21.9324 16.0407 21.3523 16.281 20.7473 16.281C20.1424 16.281 19.5622 16.0407 19.1344 15.6129C18.7067 15.1851 18.4663 14.6049 18.4663 14C18.4663 13.395 18.7067 12.8149 19.1344 12.3871C19.5622 11.9593 20.1424 11.719 20.7473 11.719C21.3523 11.719 21.9324 11.9593 22.3602 12.3871C22.788 12.8149 23.0283 13.395 23.0283 14ZM16.2946 14C16.2964 14.3013 16.2388 14.6001 16.1252 14.8792C16.0115 15.1582 15.844 15.4122 15.6322 15.6265C15.4204 15.8409 15.1684 16.0114 14.8907 16.1284C14.613 16.2454 14.315 16.3065 14.0137 16.3083C13.7123 16.3101 13.4136 16.2525 13.1345 16.1388C12.8554 16.0252 12.6014 15.8577 12.3871 15.6459C11.9542 15.2181 11.709 14.6359 11.7054 14.0273C11.7017 13.4187 11.94 12.8337 12.3678 12.4008C12.7956 11.9679 13.3778 11.7226 13.9863 11.719C14.5949 11.7154 15.18 11.9537 15.6129 12.3814C16.0458 12.8092 16.291 13.3914 16.2946 14ZM9.54732 14C9.55002 14.455 9.41739 14.9005 9.1663 15.2799C8.9152 15.6594 8.55697 15.9556 8.13713 16.131C7.71728 16.3063 7.25479 16.3529 6.8084 16.2648C6.36202 16.1767 5.9519 15.9579 5.63017 15.6362C5.30844 15.3144 5.08962 14.9043 5.00152 14.4579C4.91341 14.0115 4.96001 13.5491 5.13537 13.1292C5.31074 12.7094 5.60696 12.3511 5.9864 12.1C6.36583 11.8489 6.81135 11.7163 7.26634 11.719C7.56588 11.719 7.86249 11.778 8.13923 11.8926C8.41597 12.0073 8.66743 12.1753 8.87923 12.3871C9.09104 12.5989 9.25906 12.8504 9.37369 13.1271C9.48832 13.4038 9.54732 13.7005 9.54732 14Z"
        fill={foregroundColor}
      />
    </g>
  </Icon>
);
